const BulbIcon = () => {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3171 21.027V22.8455C10.3171 23.3423 10.6057 23.75 10.9608 23.75H13.5367C13.8943 23.75 14.1816 23.3411 14.1816 22.8455V21.027M11.2707 8.35012C10.5298 8.35043 9.81944 8.63277 9.2957 9.13506C8.77195 9.63734 8.47773 10.3184 8.47773 11.0286M21.4489 12.2085H23.75M19.1327 4.97763L20.7651 3.41287M20.3874 18.3377L22.0198 19.9012M12.2494 0.75V2.53366M3.76757 3.41166L5.38864 4.97763M2.51286 19.9012L4.13394 18.3377M3.04987 12.2085H0.75M18.8391 12.9133C18.4827 15.7578 16.5392 16.8944 15.6998 17.7195C14.8592 18.5469 15.0097 18.7117 15.0662 19.9253C15.0756 20.0754 15.0529 20.2258 14.9993 20.3672C14.9458 20.5086 14.8626 20.638 14.755 20.7474C14.6473 20.8569 14.5174 20.944 14.3732 21.0034C14.2291 21.0629 14.0738 21.0934 13.9169 21.0931H10.5819C10.4251 21.0929 10.2699 21.062 10.126 21.0024C9.98205 20.9428 9.85229 20.8557 9.74462 20.7464C9.63696 20.6371 9.55365 20.5079 9.49978 20.3667C9.44591 20.2256 9.42261 20.0754 9.4313 19.9253C9.4313 18.7346 9.54674 18.4579 8.79893 17.7195C7.84536 16.8054 5.60194 15.5148 5.60194 11.9656C5.59622 11.0839 5.78108 10.2108 6.14487 9.40103C6.50867 8.5913 7.04351 7.8626 7.71568 7.26085C8.38785 6.65911 9.18278 6.19736 10.0504 5.90473C10.9179 5.6121 11.8393 5.49492 12.7565 5.56059C13.6737 5.62626 14.5667 5.87334 15.3793 6.28627C16.1919 6.6992 16.9064 7.26902 17.4779 7.95981C18.0494 8.6506 18.4653 9.44738 18.6996 10.2999C18.9339 11.1525 18.9814 12.0423 18.8391 12.9133Z"
          stroke="#C7822D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};
export default BulbIcon;
